export const messages = {
  en: {
    translations: {}
  }
};
